import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

export interface DeskTextKind {
  kind: string
  subject: string | null
  body: string
  body_html: string | null
  source: 'company' | 'provider' | 'seed'
  updated_at: string | null
}

export interface DeskTextsPage {
  ready: boolean
  scope: 'company' | 'sp'
  lang: string
  companyId: number
  kinds: DeskTextKind[]
  variables: string[]
}

export function deskTextsQuery(scope: string, lang: string) {
  const q = new URLSearchParams()
  if (scope) q.set('scope', scope)
  if (lang) q.set('lang', lang)
  const suffix = q.toString() ? `?${q}` : ''
  return queryOptions({
    queryKey: ['settings', 'desk_texts', scope, lang],
    queryFn: () => apiGet<DeskTextsPage>(`/settings/desk_texts${suffix}`),
  })
}

export function deskTextsPost(path: string, fields: Record<string, PostValue>) {
  return apiPost<{ ok?: boolean; error?: string; message?: string; subject?: string; text?: string; html?: string; source?: string }>(
    `/settings/desk_texts${path}`,
    fields,
  )
}
